import { isHttpLookupContextConfig } from "./types/context-source";
import { JourneyNodeType } from "./types/journey-node-types";

/** Send tiles and HTTP lookup Set variable tiles own reverse ETL syncs. */
export function nodeOwnsSyncs(node: {
  type: string;
  config?: unknown;
}): boolean {
  return (
    node.type === JourneyNodeType.Sync || isHttpLookupContextConfig(node.config)
  );
}
